import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UserContext } from '../shared/services/user-context.service';

@Injectable()
export class AdminGuard implements CanActivate {
  constructor(private userContext: UserContext, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    //console.log('AdminGuard: Checking if user is an administrator...'+ this.userContext.isAdministrator());
    if (this.userContext.isAdministrator()) { //IsAdministratorOrAnnotator
      return true;
    } else {
      this.router.navigate(['/access-denied']);
      return false;
    }
  }
}
